import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowWidth from "../../../../../hooks/useWindowWidth";

export default function AnalyticsChart({ dates, amount }) {
  const windowWidth = useWindowWidth();

  const series = [
    {
      name: "Payment",
      data: amount,
    },
  ];

  const options = {
    grid: {
      show: false,
    },
    chart: {
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true,
      },
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 1,
      colors: ["#cabbd7"],
    },
    fill: {
      type: "gradient",
      colors: ["#8D40FF", "#E91E63", "#9C27B0"],
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.4,
        opacityFrom: 0,
        opacityTo: 0.9,
        stops: [0, 100],
      },
    },
    xaxis: {
      categories: dates,
    },
    axisBorder: {
      color: "green",
      show: true,
    },
    yaxis: {
      show: false,
    },
    tooltip: {
      enabled: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {

        return (
          '<div class="arrow_box">' +
          '<h6 class="date">' +
          w.globals.categoryLabels[dataPointIndex] +
          "</h6>" +
          '<h5 class="price">' +
          "€" +
          series[seriesIndex][dataPointIndex] +
          "</h5>" +
          "</div>"
        );
      },
      style: {
        fontSize: "14px",
      },
      onDatasetHover: {
        highlightDataSeries: true,
      },
    },

    colors: ["#8D40FF", "#E91E63", "#9C27B0"],
  };

  return (
    <>
      {dates && (
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={windowWidth <= 1500 ? 60 : 80}
        />
      )}
    </>
  );
}
